import ApiUtils from '@/utils/api/ApiUtils'
import S0801Const from './S0801Const'

const store = {
  state: {
    // custom state
    settingValues: {}
  },
  getters: {
    // custom getter
    getSettingValues: (state) => state.settingValues
  },
  mutations: {
    // custom mutation
    SET_SETTING_VALUES (state, payload) {
      state.settingValues = payload
    }
  },
  actions: {
    async updateSettings ({ commit, state }, payload) {
      return await ApiUtils.postData({
        data: [{ api: S0801Const.serviceName + '.updateSetting', input: payload }]
      })
    },
    async getSettingValuesFrontend ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [{ api: S0801Const.serviceName + '.getSettingValuesFrontend', input: payload }]
      })
      commit('SET_SETTING_VALUES', res[0].output)
    }
  }
}

export default S0801Const.getStore(store)
